import { pipe } from 'fp-ts/function';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { DataTestId, TextKey } from '@mews-commander/enums';
import { ApplicationState } from '@mews-commander/types';

import { Card, SpacingMediumTop, SpacingSmallTopBottom, withAsyncContainer } from '@mews-commander/ui';

import { Banner, Divider, Grid, Stack, StackItem, Title } from '@optimus-web/core';
import { LocalizedText, ScopeProvider } from '@mews/framework';
import { ServiceList } from '../../BillCardList/BillCard/ItemsGrouping';
import { hasFailed, isFetching } from '../selectors/meta';
import { areAllBillOrderItemsRebated } from '../selectors/orderItems';
import { RebateScreenOwnProps, RebateScreenProps, RebateScreenStateProps } from '../types';
import RebateReasonForm from './RebateReasonForm';
import RebateSelectAllItems from './RebateSelectAllItems';
import RebateSum from './RebateSum';

const RebateScreen = ({ billId, scope, areAllBillItemsRebated, guideLink, accountId }: RebateScreenProps) => (
    <ScopeProvider value={scope}>
        <Grid templateColumns="2fr 1fr" tabletMax={{ templateColumns: '1fr' }} gap="100">
            <div data-test-id={DataTestId.RebatesItemSelection}>
                <Card padding="300">
                    <Stack vertical spacing="300">
                        <StackItem>
                            <Banner
                                variant="info"
                                primaryText={<LocalizedText textKey={TextKey.RebateInfoMessageClosedBill} />}
                            />
                        </StackItem>
                        <StackItem>
                            <Title level={3}>
                                <LocalizedText textKey={TextKey.Items} />
                            </Title>
                            {!areAllBillItemsRebated ? <RebateSelectAllItems billId={billId} /> : <SpacingMediumTop />}
                            <Divider />
                            <SpacingSmallTopBottom>
                                <ServiceList billId={billId} isRebateScreen accountId={accountId} />
                            </SpacingSmallTopBottom>
                            <Divider />
                            <RebateSum billId={billId} />
                        </StackItem>
                    </Stack>
                </Card>
            </div>
            <div data-test-id={DataTestId.RebatesReasonForm}>
                <RebateReasonForm scope={scope} billId={billId} form={`rebateForm-${billId}`} guideLink={guideLink} />
            </div>
        </Grid>
    </ScopeProvider>
);

export default pipe(
    RebateScreen,
    withAsyncContainer,
    connect(
        createStructuredSelector<ApplicationState, RebateScreenProps, RebateScreenStateProps>({
            isFetching,
            hasFailed,
            areAllBillItemsRebated: areAllBillOrderItemsRebated,
        })
    )
) as unknown as React.ComponentType<RebateScreenOwnProps>;
